import script from "./TranslationEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationEditor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__